import { CircleData } from '../@types';

const getCircleById = (circles: Array<CircleData>, circleId: string) => {
  return circles?.find((circle) => circle.id === circleId);
};

export default getCircleById;
